// extracted by mini-css-extract-plugin
export default {"main":"Main_main__n-Qw3","container":"Main_container__iAGd9","posts":"Main_posts__2Hzpn","posts-wrapper":"Main_posts-wrapper__+RAlI","events":"Main_events__TUn4S"};